import { IonContent, IonFooter, IonImg, IonPage, IonTitle } from '@ionic/react';
import madper from '../assets/images/madper.png';
import tetra from '../assets/images/tetra.png';
import { Header } from '../components/Header';

const Offline: React.FC = () => {
    return (
        <IonPage id="offline-page" className="bg-white" style={{ '--ion-background-color': '#ffffff' }}>
            <IonContent fullscreen className="mb-auto">
                <Header />
                <IonImg className="mb-8 object-center w-40 mt-5 mx-auto" src={madper} alt="Madper Logo"></IonImg>
                <IonTitle className="text-center text-xl">Vous êtes hors ligne</IonTitle>
            </IonContent>
            <IonFooter style={{ position: 'unset' }}>
                <div className="w-28 mx-auto my-4">
                    <p className="text-[0.5rem] text-center">Application propulsée par</p>
                    <IonImg className="mx-3" src={tetra} alt="Tetra Informatique Logo" />
                </div>
            </IonFooter>
        </IonPage>
    );
};

export default Offline;
